import { render, staticRenderFns } from "./EditSender.vue?vue&type=template&id=1040a77c&scoped=true"
import script from "./EditSender.vue?vue&type=script&lang=js"
export * from "./EditSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040a77c",
  null
  
)

export default component.exports